var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
    fill: "#C2B6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.342 10.5V6.3h2.07c.468 0 .88.086 1.236.258.356.168.634.408.834.72.2.312.3.684.3 1.116 0 .436-.1.812-.3 1.128-.2.312-.478.554-.834.726-.356.168-.768.252-1.236.252h-2.07zm1.416-1.104h.594c.2 0 .374-.038.522-.114a.82.82 0 00.354-.336c.084-.152.126-.336.126-.552 0-.212-.042-.392-.126-.54a.82.82 0 00-.354-.336 1.128 1.128 0 00-.522-.114h-.594v1.992zM10.047 9.276v-1.02h1.8v1.02h-1.8zM12.539 10.5V6.792l.606.576h-1.326V6.3h2.135v4.2H12.54z",
    fill: "#6244FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 14a.75.75 0 01.75-.75h10a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zM5.25 17a.75.75 0 01.75-.75h7a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z",
    fill: "#fff"
  })));
}

export default SvgSchedule;